
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.036 37.425c3.36-5.523 3.656-8.893 1.912-10.681C35.732 25.498 33.595 25 31.19 25c-3.875 0-5.695-1.28-5.695-4.843 0-3.323 2.714-5.317 5.523-5.317.753 0 1.34.272 1.563.951.13.392.113.511-.035 1.19-.064.297-.074.433-.047.525a.282.282 0 00.033.073c.175-.359.362-.941.542-1.728.435-1.908.807-4.897 1.11-8.952A19.4 19.4 0 0022.5 3C16.741 3 11.558 5.51 7.985 9.493c1.465 5.076 2.63 8.75 3.484 11.005.167-2.418.755-4.053 1.713-4.692 1.63-1.088 2.873.557 2.873 2.681 0 2.226 3.383 5.846 5.754 6.617.348.113.698.196 1.413.342l.494.102c3.155.665 4.668 1.788 4.668 4.71 0 1.02.244 2.312.744 4.18.085.313.174.636.292 1.058.665 2.374 1.04 3.79 1.143 4.758a19.553 19.553 0 004.473-2.83zm4.72-5.849A19.377 19.377 0 0042 22.5c0-5.485-2.278-10.45-5.937-13.996-.288 3.42-.633 6.012-1.04 7.792-.635 2.784-1.57 4.217-3.192 3.264-.656-.385-1.077-.89-1.253-1.497-.119-.41-.122-.753-.047-1.193-1.622.203-3.036 1.412-3.036 3.287 0 2.277.805 2.843 3.695 2.843 2.904 0 5.486.601 7.19 2.347 1.454 1.491 1.945 3.557 1.375 6.229zm-3.5-25.588C40.985 9.935 44 15.872 44 22.5 44 34.355 34.355 44 22.499 44 10.645 44 1 34.355 1 22.5S10.645 1 22.499 1c5.212 0 9.997 1.864 13.723 4.96l.035.003-.002.025zm-7.743 35.063c.161-.439-.104-1.75-1.019-5.015a97.33 97.33 0 01-.297-1.08c-.543-2.027-.813-3.454-.813-4.697 0-1.71-.741-2.26-3.081-2.754l-.483-.1c-.787-.161-1.188-.255-1.63-.399-3.119-1.015-7.135-5.311-7.135-8.519 0-.236-.02-.443-.05-.612-.314.68-.585 2.11-.585 4.131 0 3.414-1.996 3.503-3.314.46-.851-1.965-2.062-5.638-3.644-11.046A19.39 19.39 0 003 22.5C3 33.25 11.75 42 22.499 42c2.098 0 4.12-.333 6.014-.949z"}})])
          )
        }
      }
    